import TrackWrapper from '~/components/common/TrackWrapper';
import { Content, EvGuideSection, Title } from '../styles';

export default function BatterySize() {
  return (
    <TrackWrapper event={{ eventName: 'Viewed - Ev Battery Size' }}>
      <EvGuideSection className="grid grid-cols-1 gap-xl pt-4xl sm:gap-2xl md:grid-cols-2 md:gap-7xl md:pt-0">
        <Title>Don’t get shocked: checking the battery size and range</Title>
        <Content>
          Battery size is a critical factor for determining an electric
          vehicle’s range. Battery size is measured in kWh (kilowatt-hour, or
          how much power a device can use in an hour), and in general, the
          larger the battery, the better the vehicle range. Many of today’s EVs
          are capable of traveling over 200 miles on a single charge! Some
          automakers also offer battery warranties up to a certain number of
          miles and/or years.
        </Content>
      </EvGuideSection>
    </TrackWrapper>
  );
}
